import { ProfileCard } from '@/features/profile/ui/ProfileCard/ProfileCard'
import { ThemeToggle } from '@/features/themeToggle/ui/ThemeToggle'
import { PrivateInfo } from '@/widgets/profile/ui/tabComponents/PrivateInfo/PrivateInfo'
import { ProfileRates } from '@/widgets/profile/ui/tabComponents/ProfileRates/ProfileRates'
import { ProfileTimeZone } from '@/widgets/profile/ui/tabComponents/ProfileTimeZone/ProfileTimeZone'
import { Safe } from '@/widgets/profile/ui/tabComponents/Safe/Safe'
import { UserSessions } from '@/widgets/profile/ui/tabComponents/UserSessions/UserSessions'
import { useState } from 'react'

export type ProfileTabNames = 'info' | 'safe' | 'timeZone' | 'rate' | 'sessions'

export const Profile = () => {
  const [tabName, setTabName] = useState<ProfileTabNames>('info')

  const tabComponents = {
    info: <PrivateInfo />,
    safe: <Safe />,
    timeZone: <ProfileTimeZone />,
    rate: <ProfileRates />,
    sessions: <UserSessions />,
  }

  return (
    <div className="w-full min-h-full">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-[32px] text-text-main dark:text-white">Профиль</h2>
        <div className="hidden">
          <ThemeToggle />
        </div>
      </div>
      <div className="flex xl:flex-row flex-col justify-between xl:items-start gap-4 xl:gap-8 mb-10">
        <ProfileCard setTabName={setTabName} tabName={tabName} />
        {tabComponents[tabName]}
      </div>
    </div>
  )
}
